import { Modal, Button } from 'react-bootstrap'
import styles from '../importModal/ImportModal.css'

class ImportModalError extends React.Component {
  render () {
    let {messageError, onShow, onClickTryBtn, onClickCancelBtnError} = this.props

    return (
      <div>
        <Modal show={onShow} bsClass='modal-import modal' id='modalImportError' backdrop>
          <Modal.Header>
            <Modal.Title>Import Errors</Modal.Title>
          </Modal.Header>
          <Modal.Body className='modal-body no-padding'>
            <div className='customer-body'>
              <div className='customer-scroll'>
                <div className='mk-col-right-box right-modal-customer'>
                  <div className={styles['description'] + ' text-left'}>
                    We Found {messageError.length} errors in your file. Please correct them and re-upload your file.
                  </div>
                  <div>
                    <ol>
                      {messageError.map((message, i) => {
                        return <li key={i}><span className={styles['list-type']}>{i + 1}. </span><strong className='text-error'><span className='text-red'>{JSON.stringify(message)}</span></strong></li>
                      })}
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className='btn btn-default pull-left' onClick={onClickCancelBtnError}>Cancel</Button>
            <Button className='btn btn-primary pull-right' onClick={onClickTryBtn}>Try Again</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

export default (ImportModalError)



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListLoyalty/importModalError/importModalError.js